




import { Component, Vue } from "vue-property-decorator";

@Component({})
export default class ReadingTask2 extends Vue {}
